import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "明星爆料", path: "/category/star-gossip" },
  { name: "网红黑料", path: "/category/influencer-gossip" },
  { name: "综艺爆料", path: "/category/show-gossip" },
  { name: "黑料百科", path: "/about" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-fire-line text-lg text-background-50 dark:text-foreground-950"></i>
            </div>
            <span
              className={`font-heading text-xl font-bold tracking-wide whitespace-nowrap ${
                isScrolled || !isHome ? "text-foreground-950" : "text-white"
              }`}
            >
              黑料网
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "text-primary-500"
                      : isScrolled || !isHome
                        ? "text-foreground-700 hover:text-foreground-950"
                        : "text-white/90 hover:text-white"
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          {/* Right side */}
          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`hidden md:flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                isScrolled || !isHome
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-200"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              关于我们
            </Link>
            <button
              type="button"
              className="w-9 h-9 flex items-center justify-center bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors duration-200 cursor-pointer"
              aria-label="Subscribe"
            >
              <i className="ri-notification-3-line text-base text-background-50 dark:text-foreground-950"></i>
            </button>

            {/* Mobile menu toggle */}
            <button
              type="button"
              className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <i
                className={`text-xl ${
                  isScrolled || !isHome ? "text-foreground-950" : "text-white"
                } ${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}
              ></i>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 pb-4">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-4 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200 ${
                    isActive
                      ? "text-primary-500 bg-primary-50"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
            <Link
              to="/about"
              className="block px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg mt-1"
            >
              关于我们
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}